export const openWhatsAppGroup = (groupLink: string) => {
  // Check if it's a valid WhatsApp group link
  if (!groupLink.startsWith('https://chat.whatsapp.com/')) {
    console.error('Invalid WhatsApp group link');
    return;
  }
  
  // Open WhatsApp group in a new tab
  window.open(groupLink, '_blank');
};